<template>
  <div class="order-list" id="orderList">
    <div class="order-container">
      <nav class="flex">
        <div
          v-for="(tab, index) in tabs"
          class="tab"
          :key="index"
          @click="activeIndex = index"
          :class="{ active: activeIndex === index, 'border-l': activeIndex === index && activeIndex > 0 }"
        >
          <span class="item" :class="{ active: activeIndex === index, 'no-border': activeIndex - 1 === index }">{{
            tab.text
          }}</span>
        </div>
        <div class="flex-grow border-b"></div>
      </nav>
      <div style="min-height: 1060px" v-loading="loading">
        <div v-if="orderList.length">
          <section style="marginTop: 10px" class="order" v-for="(item, idx) in orderList" :key="idx">
            <header class="flex">
              <div class="flex-grow title-flex">
                <span @click="goToOrderDetail(item)" style="cursor: pointer"
                  >下单时间: {{ dateFormate(new Date(item.order.createdAt)) }}
                  <span class="clr-b7">订单编号: {{ item.order.id }}</span></span
                >
                <span style="display: flex">
                  <span
                    :style="{
                      marginRight: '15px',
                      fontWeight: 'bold',
                      color: item.order.status === 0 ? '#C6001F' : '#333'
                    }"
                    >{{
                      item.order.status === -5
                        ? '已取消'
                        : '' || item.order.status === 88
                        ? '已完成'
                        : '' || item.order.status === -2
                        ? '已退款'
                        : '' || item.order.status === 0
                        ? '待付款'
                        : '' || item.order.status === 1
                        ? '已支付'
                        : '' || item.order.status === 80
                        ? '待处理'
                        : '' || item.order.status === 3
                        ? '待收货'
                        : '' || item.order.status === 4
                        ? '可交车'
                        : '' || item.order.status === 5
                        ? '已交车'
                        : '' || item.order.status === 6
                        ? '售后中'
                        : '' || item.order.status === -1
                        ? '已删除'
                        : '' || item.order.status === -2
                        ? '已退款'
                        : '' || item.order.status === -3
                        ? '待失效'
                        : '' || item.order.status === -4
                        ? '已失效'
                        : '' || item.order.status === -6
                        ? '已退款'
                        : '' || item.order.status === -80
                        ? '已关闭'
                        : ''
                    }}
                  </span>
                  <!-- 去掉删除按钮 jira单号EC419021400-9060 -->
                  <!-- <span class="orderDelete" style="width: 14px; height: 14px">
                    <img
                      style="width: 14px; height: 14px; margin: 0;cursor: pointer;"
                      @click="orderDelete(item.order)"
                      v-show="item.order.status === -5 || item.order.status === -4 || item.order.status === -80"
                      src="@/assets/images/seller/delete.png"
                    />
                  </span> -->
                </span>
              </div>
              <div v-if="item.order.status === 0" class="color-666 flex-center">
                <i class="icon-clock"></i>
                <!-- <CountDown text="付款截止:剩余" @timeEnd="timeEnd(1)" :endTime="item.order.payOutTime" /> -->
                <CountDown text="付款截止:剩余" @timeEnd="timeEnd(1)" :endTime="item.order.payOutTime" />
              </div>
            </header>
            <div style="display: flex">
              <div>
                <div class="flex-center main" v-for="(attr, attrIndex) in item.orderContracts" :key="attrIndex">
                  <div>
                    <div
                      v-for="(goodsList, index) in attr.orderItemDtoList"
                      class="one-of-order"
                      :key="index"
                      @click="goToDetail(goodsList, idx)"
                      style="cursor: pointer; marginTop: 10px"
                    >
                      <div class="flex" :key="index">
                        <div class="img-container">
                          <img :src="goodsList.itemImage" alt="" mode="widthFix" />
                        </div>
                        <div class="goods-inf">
                          <div class="title">
                            <!-- <span v-if="item.activityType === 3 && goodsList.order.orderType == 0" class="groupTag">
                          <img src="../../assets/images/activity/lottery/prize.png" alt="" />
                        </span>
                        <span v-if="item.isgroupType" class="groupTag">
                          <img src="../../assets/images/activity/groupTag.png" alt="" />
                        </span>
                        <span v-if="item.activityType === 7" class="crowdTag">
                          <img src="../../assets/images/activity/crowdfunding/crowdTag.png" alt="" />
                        </span>
                        <span v-if="item.activityType === 8" class="auctionTag">{{ item.tagName }}</span> -->
                            <span
                              v-if="
                                goodsList.extraMap && goodsList.extraMap.activity && goodsList.extraMap.activity.tag
                              "
                              :class="
                                goodsList.extraMap.activity.activityType !== 18
                                  ? 'activityTag'
                                  : 'activityTag depositTag'
                              "
                              >{{ goodsList.extraMap.activity.tag }}</span
                            >
                            <!-- 如果是赠品 就显示赠品标签 -->
                            <span v-else-if="goodsList.extraMap && goodsList.extraMap.bofogPurchase" class="activityTag"
                              >赠品</span
                            >
                            <!-- 如果是搭配购搭配商品 就显示搭配商品标签 -->
                            <span
                              v-else-if="goodsList.extraMap && goodsList.extraMap.collocationPurchase"
                              class="activityTag"
                              >搭配购</span
                            >
                            <!-- <div class="deposit-box">
                              <img
                                v-if="
                                  goodsList.extraMap &&
                                    goodsList.extraMap.activity &&
                                    goodsList.extraMap.activity.activityType == 18
                                "
                                class="deposit-tag"
                                src="../../assets/images/activity/deposit-tag.png"
                              />
                            </div> -->
                            <img
                              class="prizeTab"
                              style="width: 42px; height: 21px; margin: 0"
                              mode="widthFix"
                              v-if="
                                (item.order.extraMap && item.order.extraMap.orderChannel === '3') ||
                                  (item.order.extraMap && item.order.extraMap.orderChannel === 3)
                              "
                              src="@/assets/images/activity/lottery/prize.png"
                            />
                            {{ goodsList.itemName }}
                            <!-- <span v-if="goodsList.order.orderType == 8">
                          {{ getSkuText(goods.attributeMap) }}
                        </span> -->
                          </div>
                          <p v-if="goodsList.attributeMaps">
                            <span
                              style="marginRight: 10px"
                              v-for="(item, index) in goodsList.attributeMaps"
                              :key="index"
                            >
                              {{ item.attrKey ? item.attrKey + ':' + item.attrVal : '' }}
                            </span>
                          </p>
                          <p>
                            <span style="marginRight: 10px"
                              >价格：{{ Number(goodsList.skuPrice) | currency('￥', 2) }}</span
                            >
                            <span>数量: x{{ goodsList.quantity }}</span>
                          </p>
                          <p v-if="goodsList.itemType === '0' || goodsList.itemType === 0">
                            <span
                              v-if="
                                goodsList.extraMap && goodsList.extraMap.dealer && goodsList.extraMap.dealer.dealerName
                              "
                              >经销商：{{ goodsList.extraMap.dealer.dealerName }}</span
                            >
                          </p>
                          <!-- <p v-if="goodsList.order.orderType == 0">
                        <span v-for="(attr, index) in goods.attributeMap" :key="index">
                          <span class="mr-10" v-for="(value, key) in attr.attributeMap" :key="key"
                            ><span class="mr-5">{{ key }}:</span>{{ value }}</span
                          >
                        </span>
                      </p>
                      <p v-else class="flex-align color-gray item-start">
                        <span class="flex-grow width-180">{{
                          goods.extraMap && goods.extraMap.dealer ? goods.extraMap.dealer.dealerName : ''
                        }}</span>
                      </p> -->
                        </div>
                        <div class="align-center status">
                          <div :style="{ color: goodsList.status === 0 ? '#C6001F' : '#333' }" class="status-text">
                            <!-- {{ statusText[item.activityType === 9 ? transType(goodsList.status) : item.status] }} -->
                            {{
                              goodsList.status === 0
                                ? ''
                                : '' || goodsList.status === 1
                                ? '待付款'
                                : '' || goodsList.status === 2
                                ? '待发货'
                                : '' || goodsList.status === 3
                                ? '待收货'
                                : '' || goodsList.status === 4
                                ? '已收货'
                                : '' || goodsList.status === 5
                                ? '已完成'
                                : '' || goodsList.status === 7
                                ? '申请退款'
                                : '' || goodsList.status === 8
                                ? '申请退货退款'
                                : '' || goodsList.status === 9
                                ? '已退款'
                                : '' || goodsList.status === 10
                                ? '已退货退款'
                                : '' || goodsList.status === -1
                                ? '已失效'
                                : '' || goodsList.status === -2
                                ? '已关闭'
                                : ''
                            }}
                            <!-- goodsList.status === 0正常状态不展示 -->
                          </div>
                        </div>
                        <div class="align-center price">
                          {{ goodsList.fee | currency('￥', 2) }}
                          <!-- <p class="tip" v-if="goodsList.order.orderType == 8">订金</p> -->
                          <p class="tip" v-if="goodsList.itemType === '0' || goodsList.itemType === 0">订金</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-grow flex-center">
                <div class="dividing"></div>
                <div class="operation show-btn">
                  <div>
                    <el-popover
                      popper-class="smallOrderGroupDetail"
                      placement="left"
                      width="280"
                      trigger="hover"
                      v-if="
                        (item.order.status === 1 || item.order.status === 88) &&
                          item.showSmallGroup &&
                          item.isSmallGroup &&
                          item.smallGroupNum > 0
                      "
                      @show="
                        showInvite(
                          item.order.id,
                          item.orderContracts[0].orderItemDtoList[0].extraMap.activity.gpRecordId
                        )
                      "
                      @hide="hiddenInvite(item.order.id)"
                    >
                      <div class="price-box">
                        <div class="box-title" v-if="item.smallGroupNum > 0">
                          <div class="left">参团成功</div>
                          <div class="right">
                            邀约{{ item.smallGroupNum }}人即享<span class="equity-name">{{
                              item.smallGroupTitle
                            }}</span>
                          </div>
                        </div>
                        <div class="box-title" v-else>
                          <div class="left">恭喜您已组团成功,完成购买后</div>
                          <div class="right">
                            获得<span class="equity-name">{{ item.smallGroupTitle }}</span>
                          </div>
                        </div>
                        <div class="bottom">
                          <div class="qrCode-wrap">
                            <div :id="'qrCodeOrderItem' + item.order.id" ref="qrCodeDiv"></div>
                            <p class="text">微信扫码查看邀约详情</p>
                          </div>
                        </div>
                      </div>
                      <div
                        slot="reference"
                        v-if="
                          (item.order.status === 1 || item.order.status === 88) &&
                            item.showSmallGroup &&
                            item.isSmallGroup &&
                            item.smallGroupNum > 0
                        "
                        class="btn pay"
                      >
                        邀约参团
                      </div>
                    </el-popover>

                    <el-popover
                      popper-class="smallOrderGroupDetail"
                      placement="left"
                      width="280"
                      trigger="hover"
                      v-if="
                        (item.order.status === 1 || item.order.status === 88) &&
                          item.showSmallGroup &&
                          item.isSmallGroup &&
                          item.smallGroupNum <= 0
                      "
                      @show="
                        showInvite(
                          item.order.id,
                          item.orderContracts[0].orderItemDtoList[0].extraMap.activity.gpRecordId
                        )
                      "
                      @hide="hiddenInvite(item.order.id)"
                    >
                      <div class="price-box">
                        <div class="box-title" v-if="item.smallGroupNum > 0">
                          <div class="left">参团成功</div>
                          <div class="right">
                            邀约{{ item.smallGroupNum }}人即享<span class="equity-name">{{
                              item.smallGroupTitle
                            }}</span>
                          </div>
                        </div>
                        <div class="box-title" v-else>
                          <div class="left">恭喜您已组团成功,完成购买后</div>
                          <div class="right">
                            获得<span class="equity-name">{{ item.smallGroupTitle }}</span>
                          </div>
                        </div>
                        <div class="bottom">
                          <div class="qrCode-wrap">
                            <div :id="qrCodeOrderItem + item.order.id" ref="qrCodeDiv"></div>
                            <p class="text">微信扫码查看邀约详情</p>
                          </div>
                        </div>
                      </div>
                      <div
                        slot="reference"
                        class="inviteDetail"
                        v-if="
                          (item.order.status === 1 || item.order.status === 88) &&
                            item.showSmallGroup &&
                            item.isSmallGroup &&
                            item.smallGroupNum > 0
                        "
                      >
                        邀约详情
                      </div>
                    </el-popover>

                    <div class="btn pay" v-if="item.order.status === 0" @click.stop="pay(item)">立即付款</div>
                    <div
                      class="btn black"
                      @click="confirmReceipt(item.orderContracts, idx)"
                      v-if="item.isReceiving === true"
                    >
                      确认收货
                    </div>
                  </div>
                  <div class="check-btn-flex">
                    <span class="show-underline" @click="checkDetails(item.order.id)">查看详情</span>
                    <span
                      class="show-underline"
                      style="margin-left"
                      @click="cancelOrder(item, idx)"
                      v-if="item.order.status === 0"
                      >取消订单</span
                    >
                    <span
                      class="show-underline"
                      style="margin-left"
                      @click="visitLogistics(item)"
                      v-if="item.isReceiving === true"
                      >查看物流</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="line-c" v-if="idx < orderList.length - 1"><div class="line"></div></div>
          </section>
        </div>
        <WithoutData v-else-if="!loading" />
      </div>
    </div>
    <div class="page">
      <el-pagination
        v-if="paginationShow"
        v-show="totalCount > pageSize"
        :pageSize="pageSize"
        :pageCount="pageSize"
        layout=" prev, pager, next, jumper"
        @current-change="pageChange"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <CancelOrder ref="cancel" :orderId="orderId" :reasonId="reasonId" @cancel="onCancel" />
    <!-- 物流box -->
    <LogisticsBox ref="log" :orderItems="orderDelivery" v-if="orderDelivery" />
    <!-- 物流box end -->
    <el-dialog
      title="请选择要查看的物流单"
      :visible.sync="logisticsDialog"
      :lock-scroll="false"
      center
      width="620px"
      :before-close="logisticsCheck"
    >
      <div v-loading="logisticsLoading" class="logistic-box">
        <header
          class="flex-start-box"
          v-for="(item, index) in orderContracts"
          :key="index"
          style="align-items: center; marginTop: 10px"
        >
          <div class="goods-inf">
            <img :src="item.orderItemDtoList[0].itemImage" />
            <p>{{ item.orderItemDtoList.length }}件商品</p>
          </div>
          <div class="express-box">
            <div class="express">
              <div><span>配送企业:</span>{{ item.orderDelivery ? item.orderDelivery[0].expressName : '' }}</div>
              <div class="margin-top5">
                <span>快递单号:</span>{{ item.orderDelivery ? item.orderDelivery[0].expressNum : '' }}
              </div>
              <!-- <div><span >联系电话:</span>{{item.orderDelivery[0].expressName}}</div> -->
            </div>
            <div class="check-box">
              <div class="btn black" v-if="item.orderDelivery" @click="checklogistic(item)">查看物流</div>
              <div class="btn black" style="background: #dcdcdc" v-else>查看物流</div>
            </div>
          </div>
        </header>
      </div>
    </el-dialog>
    <!-- 确认收货弹出框 -->
    <el-dialog
      title="请选择物流单"
      custom-class="logisticDialog"
      :visible.sync="showConfirm"
      center
      width="620px"
      :before-close="logisticsShow"
    >
      <div v-loading="confirmLoading" style="marginTop: 10px" class="logistic-box">
        <header
          class="flex-start"
          v-for="(attr, attrIndex) in receivingList"
          :key="attrIndex"
          style="align-items: center; marginTop: 10px"
        >
          <div class="goods-inf">
            <img :src="attr.orderItemDtoList[0].itemImage" />
            <p>{{ attr.orderItemDtoList.length }}件商品</p>
          </div>
          <div class="express-box">
            <div class="express">
              <div><span>配送企业:</span>{{ attr.orderDelivery ? attr.orderDelivery[0].expressName : '' }}</div>
              <div class="margin-top5">
                <span>快递单号:</span>{{ attr.orderDelivery ? attr.orderDelivery[0].expressNum : '' }}
              </div>
              <!-- <div><span >联系电话:</span>{{item.orderDelivery[0].expressName}}</div> -->
            </div>
            <div class="check-box">
              <div
                class="btn black"
                v-if="attr.status === '3' || attr.status === 3"
                @click="singleConfirm(attr, attrIndex)"
              >
                确认收货
              </div>
              <div class="btn black" style="background: #dcdcdc" v-else>确认收货</div>
            </div>
          </div>
        </header>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dateFormate, getStorage } from '@/lib/utils'
import CountDown from '@/components/common/CountDown'
import WithoutData from '@/components/common/WithoutData'
import CancelOrder from '@/components/business/order/cancelOrder.vue'
import LogisticsBox from '@/components/business/order/logisticsBox.vue'
import myorderApi from '@/api/myorder'
import QRCode from 'qrcodejs2'
// import aConfig from '@/lib/activityConfig'
export default {
  name: 'orderList',
  components: {
    CountDown,
    WithoutData,
    CancelOrder,
    LogisticsBox
    // QRCode
  },
  data() {
    return {
      receivingList: [],
      activityTag: {
        2: '搭配购',
        3: '抽奖类',
        5: '限时抢购',
        6: '团购',
        8: '集客',
        9: '主题',
        10: '投票',
        11: '裂变',
        14: '签到集卡',
        16: '邀请下单',
        18: '预售',
        19: '神券',
        20: '拍卖',
        21: '买赠'
      },
      confirmLoading: false, // 确认收货loading
      showConfirm: false,
      activeIndex: 0,
      tabs: [
        {
          text: '全部订单',
          status: ''
        },
        {
          text: '待付款',
          status: 0
        },
        {
          text: '待发货',
          status: 2
        },
        {
          text: '待收货',
          status: 3
        }
      ],
      statusText: ['待付款', '待收货', '待发货', '已完成', '已取消', '已付款', '已退款', '已完成'], // 状态字符
      orderList: [
        {
          orderContracts: [],
          order: {
            updatedAt: ''
          }
        }
      ],
      loading: false,
      totalCount: 0,
      pageNo: 1,
      pageSize: 5,
      dateFormate,
      orderId: '', // 取消订单id
      reasonId: '', // 取消订单获取理由id
      logisticsOrder: null, // 物流order
      cancelIndex: -1,
      paginationShow: true,
      qrcode: '',
      activityExtra: {
        // 活动相关内容
        grouponInfo: null
      },
      isGroup: null, // 团购隐藏退货
      crowdfundingInfo: {},
      logisticsList: [], // 物流信息
      logisticsDialog: false, // 物流弹窗
      orderDelivery: null,
      logisticsLoading: false, // 物流loading
      orderContracts: []
    }
  },
  created() {
    this.getData(1)
  },
  methods: {
    bindQRCode(id, otherId) {
      // this.$nextTick(() => {
      const recordId = otherId || ''
      const dealercardwebUrl = getStorage('domain', 'localStorage').h5mallUrl
      const url = dealercardwebUrl + '/pages/activity/smallGroupDetail?orderId=' + id + '&recordId=' + recordId
      let code = null
      this.$nextTick(function() {
        code = new QRCode(document.getElementById(`qrCodeOrderItem${id}`), {
          text: url,
          width: 220,
          height: 220,
          colorDark: '#000000', // 二维码颜色
          colorLight: '#ffffff', // 二维码背景色
          correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
        })
      })
      // code.clear()
      // code.makeCode(url) // 生成另一个新的二维码
      return code
      // })
    },
    /* 二维码显隐 */
    showInvite(id, recordId) {
      this.$nextTick(function() {
        this.bindQRCode(id, recordId)
      })
    },
    hiddenInvite(id) {
      document.getElementById(`qrCodeOrderItem${id}`).innerHTML = ''
    },
    /* 二维码显隐end */

    // handleRealShow(val) {
    //   this.logisticsDialog = val
    // },
    /**
     * @descripttion: 查看单个物流
     * @Author: cuiyuan
     * @Date: 2021-01-22 18:30:13
     * @param {obj} item 对应数据
     * @return {void}
     */
    checklogistic(item) {
      if (item.orderDelivery) {
        let obj = {
          expressCode: item.orderDelivery && item.orderDelivery[0].expressCode,
          expressNum: item.orderDelivery && item.orderDelivery[0].expressNum,
          img: item.orderDelivery && item.orderItemDtoList[0].itemImage,
          number: item.orderItemDtoList.length,
          orderItemId: item.orderItemDtoList[0].id,
          expressName: item.orderDelivery && item.orderDelivery[0].expressName
        }
        this.orderDelivery = obj
        // this.logisticsDialog = false
      }
      this.$nextTick(() => {
        this.$refs.log.show = true
      })
    },
    goToOrderDetail(item) {
      this.$router.push(`/personCenter/orderDetail?id=${item.order.id}`)
    },
    goToDetail(item, idx) {
      // 赠品跳到主商品详情
      if (item.extraMap.bofogPurchase || item.extraMap.collocationPurchase) {
        // 找到当前点击的商品的主商品
        this.orderList[idx].orderContracts.forEach((fitem) => {
          fitem.orderItemDtoList.forEach((order) => {
            if (order.extraMap.activity) {
              this.goToDetail(order)
            }
          })
        })
        return
      }
      let ladderIndex = item.extraMap && item.extraMap.activity && item.extraMap.activity.ladderIndex
      if (item.itemType === '0') {
        this.$router.push({
          path:
            '/details/allCars?id=' +
            item.itemId +
            (item.extraMap.activity && item.extraMap.activity.activityId
              ? '&activityId=' + item.extraMap.activity.activityId
              : '') +
            (ladderIndex ? '&ladderIndex=' + ladderIndex : '')
        })
      } else {
        this.$router.push({
          path:
            '/details/boutiqueAccessories?id=' +
            item.itemId +
            (item.extraMap.activity && item.extraMap.activity.activityId
              ? '&activityId=' + item.extraMap.activity.activityId
              : '') +
            (ladderIndex ? '&ladderIndex=' + ladderIndex : '')
        })
      }
    },
    getData(pageNo) {
      // 传给后端的参数status 0 -> null, 1 -> 3, 2 -> 5, 3 -> 2, 4 -> -80
      const params = {
        pageNo,
        pageSize: this.pageSize,
        vmId: 1
      }
      const transStatus = [null, 0, 2, 3]
      if (this.activeIndex) {
        params.status = transStatus[this.activeIndex]
      }
      myorderApi.MyorderList(params).then(
        (res) => {
          const { total, data } = res.data
          this.totalCount = total
          this.orderList = data
          this.orderList.map((res) => {
            res.orderContracts.map((item) => {
              if (item.status === '3') {
                this.$set(res, 'isReceiving', true)
              }
            })
          })
          this.orderList.map((res) => {
            res.orderContracts.map((item) => {
              item.orderItemDtoList.map((attr) => {
                if (attr.extraMap && attr.extraMap.smallGroup) {
                  this.$set(res, 'showSmallGroup', true)
                  this.$set(res, 'smallGroupTitle', attr.extraMap.smallGroup.title)
                }

                let smallGroupNum = 0
                if (attr.bizGroupPurchaseShareDetailVo && attr.bizGroupPurchaseShareDetailVo.bizShareFissionVo) {
                  smallGroupNum =
                    attr.bizGroupPurchaseShareDetailVo.bizShareFissionVo.quantity -
                    attr.bizGroupPurchaseShareDetailVo.bizShareGroupJoinRecordVo.length
                  this.$set(res, 'smallGroupNum', smallGroupNum)
                  if (attr.bizGroupPurchaseShareDetailVo) {
                    attr.bizGroupPurchaseShareDetailVo.bizShareGroupJoinRecordVo.map((attrItem) => {
                      let userInfo = getStorage('userInfo')
                      if (userInfo.accountId === attrItem.userId && (attrItem.status === 1 || attrItem.status === 2)) {
                        this.$set(res, 'isSmallGroup', true)
                      }
                    })
                  }
                }
              })
            })
          })
        },
        () => {
          this.loading = false
        }
      )
    },
    // 状态转换
    transType(status) {
      const stateTrans = {
        80: 0, // 待处理
        0: 0, // 待付款积分
        3: 0, // 待付款现金
        1: 2, // 待发货
        5: 1, // 待收货
        2: 3, // 已完成
        '-2': 6, // 已退款
        '-3': 0, // 待关闭 (支付了积分没支付现金)
        '-4': 4, // 订单失效 (支付超时)
        '-80': 7, // 已完成(不能申请售后)
        '-5': 4 // 交易关闭 (取消)
      }
      return stateTrans[status]
    },
    // 页码切换
    pageChange(pageNo) {
      this.pageNo = pageNo
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.getData(pageNo)
    },
    cancelOrder(item, idx) {
      this.orderId = item.order.id
      this.cancelIndex = idx
      this.$refs.cancel.show = true
    },
    // 订单取消成功回调
    onCancel() {
      if (this.cancelIndex === -1) return
      const index = this.cancelIndex
      // if (this.activeIndex === 1) {
      //   this.orderList.splice(index, 1)
      // } else {
      const order = this.orderList[index]
      order.status = -5
      this.$set(this.orderList, index, order)
      // }
      this.cancelIndex = -1
      this.getData(this.pageNo)
    },
    // 查看物流
    visitLogistics(item) {
      this.logisticsDialog = true
      this.$nextTick(() => {
        this.orderContracts = item.orderContracts
      })
      // this.$nextTick(() => {
      //   if (item.orderContracts[0].orderDelivery) {
      //     let obj = {
      //       expressCode: item.orderContracts[0].orderDelivery && item.orderContracts[0].orderDelivery[0].expressCode,
      //       expressNum: item.orderContracts[0].orderDelivery && item.orderContracts[0].orderDelivery[0].expressNum,
      //       img: item.orderContracts[0].orderDelivery && item.orderContracts[0].orderDelivery[0].itemImage,
      //       number: item.orderContracts[0].orderItemDtoList.length,
      //       orderItemId: item.orderContracts[0].orderItemDtoList[0].id,
      //       expressName: item.orderContracts[0].orderDelivery && item.orderContracts[0].orderDelivery[0].expressName
      //     }
      //     this.orderDelivery = obj
      //   }
      //   console.log(this.orderDelivery, 'uuuu')
      // })
    },
    // 查看商品详情
    showItemDetail(goods, activityId, activityType) {
      const query = { id: goods.itemId }
      if (~~goods.itemType === 0 && activityType !== 9) {
        // 精品
        this.$router.push({ name: 'detail', query })
      } else if (~~goods.itemType === 8) {
        // 整车
        if (activityType === 3) {
          // 抽奖
          return this.$router.push(`/seller/detailcar?activityId=${this.acId}&id=${goods.itemId}`)
        } else if (activityType === 6) {
          this.$router.push({ name: 'group-detail', query: { activityId: activityId, id: goods.itemId } })
        } else if (activityType === 5) {
          // 限时抢购 or 一口价
          this.$router.push({ name: 'flashSaleCar', query: { activityId: activityId, id: goods.itemId } })
        } else if (activityType === 7) {
          this.$router.push({
            name: 'crowdfundingDetail',
            query: { activityId: activityId, id: goods.itemId, ladderIndex: this.ladderIndex }
          })
        } else if (activityType === 8) {
          this.$router.push({ name: 'auctionCar', query: { activityId: activityId, id: goods.itemId } })
        } else if (activityType === 9) {
          this.$router.push({ name: 'buy-gifts', query: { activityId: activityId, id: goods.itemId } })
        } else {
          this.$router.push({ name: 'detailCar', query })
        }
      }
    },
    pay(item) {
      this.$router.push(`/order/payConfirm/${item.order.id}`)
    },
    // getSkuText(map) {
    //   let textArr = []
    //   map &&
    //     map.forEach((attr) => {
    //       for (let key in attr.attributeMap) {
    //         textArr.push(attr.attributeMap[key])
    //       }
    //     })
    //   return textArr.join('/')
    // },
    // 支付超时
    timeEnd(idx) {
      // this.$set(this.orderList[idx], 'type', 4)
      this.getData(this.pageNo)
    },
    logisticsShow() {
      this.showConfirm = false
    },
    logisticsCheck() {
      this.logisticsDialog = false
    },
    // 单个确认收货
    singleConfirm(item, index) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll: false
      }).then(() => {
        // 确认收货
        myorderApi
          .arrive({
            orderContractId: item.id
          })
          .then((res) => {
            if (res.status === 200) {
              this.$feedback('已确认收货')
              this.getData(this.pageNo)
              this.showConfirm = false
              // this.$set(this.orderList[idx], 'type', 3)
            } else {
              this.$feedback(res.message)
            }
          })
      })
    },
    // 确认收货
    confirmReceipt(item, idx) {
      if (item.length === 1) {
        this.$confirm('是否确认收货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // 确认收货
          myorderApi
            .arrive({
              orderContractId: item[0].id
            })
            .then((res) => {
              if (res.status === 200) {
                this.$feedback('已确认收货')
                this.getData(this.pageNo)
                // this.$set(this.orderList[idx], 'type', 3)
              } else {
                this.$feedback(res.message)
              }
            })
        })
      } else if (item.length > 1) {
        this.$nextTick(() => {
          this.receivingList = item.filter((item) => item.type !== '0' && item.type !== '3') || []
          this.showConfirm = true
        })
      }
    },
    /**
     * @descripttion: 崔源
     * @Author: cuiyuan
     * @Date: 2021-01-21 23:36:50
     * @param {obj} item [当前的订单数据]
     * @return {void}
     */
    jumpAfter(item) {
      this.$router.push(`/personCenter/rejectSubmit?orderId=${item.order.id}&itemType=${item.order.orderType}`)
    },
    /**
     * @descripttion: 崔源
     * @Author: cuiyuan
     * @Date: 2021-01-21 19:59:50
     * @param {number} id [订单id]
     * @return {void}
     */
    checkDetails(id) {
      this.$router.push(`/personCenter/orderDetail?id=${id}`)
    },
    // 删除订单
    orderDelete(item) {
      const orderId = item.id
      this.$confirm('亲，确定删除该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myorderApi.orderDelete({ orderId: orderId }).then(
            (res) => {
              if (res.status === 200) {
                this.$feedback('删除成功')
                this.getData(this.pageNo)
              }
            },
            (res) => {
              this.$feedback(res.message)
            }
          )
        })
        .catch(() => {
          this.$feedback('已取消删除！')
        })
    }
  },
  mounted() {},
  watch: {
    activeIndex() {
      this.paginationShow = false
      this.$nextTick(() => {
        this.paginationShow = true
      })
      this.getData(1)
    }
  }
}
</script>

<style scoped lang="scss">
// ::v-deep .logisticDialog {
//   padding: 0 !important;
// }
@mixin icon($size, $icon, $mr) {
  background: url($icon);
  display: inline-block;
  height: $size;
  width: $size;
  background-size: $size $size;
  margin-right: $mr;
}
nav {
  box-sizing: border-box;
  /*height: 57px;*/
  overflow: hidden;
  .tab {
    @extend .flex-center;
    width: 127px;
    height: 56px;
    box-sizing: border-box;
    border-bottom: 1px solid #d4d4d4;
    cursor: pointer;
    text-align: center;
    span {
      font-size: 14px;
    }
    &.active {
      border-top: 2px #c6001f solid;
      border-right: 1px #d4d4d4 solid;
      color: #c6001f;
      position: relative;
      border-bottom: none;
      font-weight:bold;
      &:before {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        content: '';
        width: 0;
        height: 0;
        border-width: 4px 4px 0;
        border-style: solid;
        border-color: #c6001f transparent transparent;
      }
    }
  }
  .item {
    display: inline-block;
    width: 100%;
    height: 20px;
    line-height: 20px;
    border-right: 1px solid #d4d4d4;
    &.active {
      transform: translateY(-1px);
      border-right: 1px solid #fff;
    }
    &.no-border {
      border-right: 1px solid #fff;
    }
  }
}

.codeBox {
  width: 260px;
  height: 315px;
  margin: 0 auto;
  .redBox {
    text-align: center;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    color: #333;
    margin: 16px 0 20px 0;
    span {
      color: #f54358;
    }
    .joinText {
      cursor: pointer;
      color: #f54358;
      text-decoration: underline;
    }
  }
  .groupSuccess {
    margin-top: 0px;
    margin-bottom: 5px;
  }
  .qrcodeBox {
    height: 220px;
    width: 220px;
    margin: 0px auto 0px;
  }
  .shareText {
    text-align: center;
    color: #666;
    display: block;
    font-size: 18px;
    margin: 14px 0 0px 0;
  }
}
.crowdBox {
  width: 260px;
  height: 300px;
  margin: 0 auto;
  .qrcodeBox {
    height: 220px;
    width: 220px;
    margin: 30px auto 0px;
  }
  .gearText {
    text-align: center;
    color: #666;
    display: block;
    font-size: 18px;
    margin: 26px 0 30px 0;
    span {
      color: #c6001f;
    }
  }
}
p {
  font-size: 16px/1;
}
.order-container {
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 5px 1px rgba(224, 224, 224, 0.5);
}

.page {
  height: 32px;
  background: #f9f9f9;
  // position: relative;
  display: flex;
  justify-content: center;
  margin: 40px auto 50px;
}
.order {
  position: relative;
  text-align: left;
  padding: 19px 55px 22px 25px;
  box-sizing: border-box;
  .title-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  header {
    font-size: 14px;
    color: #777;
  }
  .icon-clock {
    @include icon(17px, '../../assets/icons/order/icon-clock.png', 5px);
  }
  .main {
    position: relative;
    padding-top: 14px;
    box-sizing: border-box;
  }
  .orderContracts {
    display: flex;
    flex-direction: column;
    .one-of-order {
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .clr-b7 {
    color: #b7b7b7;
    margin-left: 14px;
  }
  .img-container {
    height: 143px;
    width: 202px;
    cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
    img {
      // display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      // height: 143px;
      // width: 202px;
    }
  }
  .goods-inf {
    width: 377px;
    box-sizing: border-box;
    padding: 0px 14px 0;
    font-size: 16px;
    color: #333;
    .title {
      .groupTag {
        position: relative;
        top: 5px;
      }
      .crowdTag {
        position: relative;
        top: 7px;
      }
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
    }
    p {
      margin-top: 8px;
    }
  }
  .status {
    // width: 64px;
    // width: 100%;
    width: 96px;
    text-align: center;
    font-size: 16px;
    position: relative;
    .status-text {
      font-weight: bold;
    }
  }
  .price {
    position: relative;
    text-align: center;
    width: 177px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    .tip {
      position: absolute;
      font-size: 14px;
      color: #666;
      left: 50%;
      transform: translateX(-50%);
      top: 21px;
      font-weight: 400;
    }
  }
  .dividing {
    height: 60px;
    width: 2px;
    background: #e0e0e0;
  }
  .show-btn {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    .check-btn-flex {
      display: flex;
      justify-content: space-around;
    }
    .show-underline {
      color: #666666;
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .operation {
    width: 178px;
    text-align: center;
    margin-left: 10px;
    .groupBtn,
    .crowdBtn {
      margin-bottom: 10px;
      ::v-deep {
        .el-button--danger {
          width: 133px;
          height: 40px;
          background-color: #c6001f;
          font-size: 18px;
        }
        .el-button--info {
          width: 133px;
          height: 40px;
          background-color: #333333;
          font-size: 18px;
        }
        .el-button {
          // padding: 8px 0;
          border-radius: 0;
        }
      }
    }
    &::v-deep .el-popover {
      .price-box {
        margin-left: 37px;
        width: 373px;
        height: 349px;
        background: #fff;
        margin-bottom: 50px;
        .box-title {
          margin-top: 23px;
          font-size: 20px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          color: #252525;
          display: flex;
          flex-direction: column;
          align-items: center;
          .coupon {
            color: #c6001f;
            text-decoration: underline;
          }
        }
        .bottom {
          display: flex;
          justify-content: center;
          .qrCode-wrap {
            margin-top: 20px;
            width: 220px;
            height: 243px;
            .text {
              text-align: center;
              height: 23px;
              line-height: 23px;
            }
          }
        }
        li {
          font-size: 18px;
          margin-top: 16px;
          &:last-child {
            font-weight: 500;
          }
          span {
            font-weight: 500;
          }
        }
      }
    }
  }
  .line-c {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 30px;
    width: 100%;
    height: 1px;
    box-sizing: border-box;
    margin: 1px 0;
  }
  .line {
    height: 1px;
    background: #d4d4d4;
  }
}
.float-l {
  float: left;
}
.flex {
  display: flex;
}
.flex-center {
  display: flex;
  align-items: center;
}
.title {
  display: flex;
  align-items: flex-end;
  .activityTag {
    padding: 0 3px;
    color: #fff;
    background: #df3d36;
    font-weight: 400;
    height: 21px;
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 500;
    line-height: 21px;
    margin-right: 5px;
  }
  .depositTag {
    background: linear-gradient(145deg, #ef5d42 0%, #da1f46 100%);
  }
  .deposit-box {
    height: 26px;
    line-height: 40px;
    display: table-cell;
    vertical-align: bottom;
    margin-right: 5px;
    .deposit-tag {
      width: 70px;
      height: 30px;
    }
  }
  .prizeTab {
    padding: 0 3px;
    height: 21px;
    margin-right: 5px;
  }
}

.flex-grow {
  flex-grow: 1;
}
.align-center {
  align-self: center;
}
.border-b {
  border-bottom: 1px solid #d4d4d4;
}
.border-l {
  border-left: 1px solid #d4d4d4 !important;
}
.color-666 {
  color: #666;
  font-size: 14px;
}
.mt-5 {
  margin-top: 5px;
}
.margin-left20 {
  margin-left: 16px;
}
.margin-left5 {
  margin-left: 5px;
}
.mr-5 {
  margin-right: 5px;
}
.mr-10 {
  margin-right: 10px;
}
.underline {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #333;
  }
}
.auctionTag {
  display: inline-block;
  // width: 30px;
  padding: 0 3px;
  height: 19px;
  color: #fff;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  background: #c6001f;
  margin-right: 3px;
  padding: 0 2px;
}
// 确认收货弹窗
.logistic-box {
  .flex-start {
    display: flex;
    align-items: flex-start;
    text-align: left;
    .goods-inf {
      position: relative;
      p {
        position: absolute;
        width: 100%;
        line-height: 28px;
        height: 28px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        bottom: 0;
        background: rgba(37, 37, 37, 0.8);
      }
      img {
        width: 162px;
        height: 114px;
      }
    }
    .express-box {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .express {
        padding: 3px 25px;
        font-size: 15px;
        color: #333;
        .margin-top5 {
          margin-top: 15px;
        }
        .fw-500 {
          font-weight: 500;
        }
      }
    }
  }
}
// 物流弹窗
::v-deep.logistic-box {
  .flex-start-box {
    display: flex;
    align-items: flex-start;
    text-align: left;
    // .flex-start {
    //   display: flex;
    //   align-items: flex-start;
    //   justify-content: center;
    //   text-align: left;
    .goods-inf {
      position: relative;
      p {
        position: absolute;
        width: 100%;
        line-height: 28px;
        height: 28px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        bottom: 0;
        background: rgba(37, 37, 37, 0.8);
      }
      img {
        width: 162px;
        height: 114px;
      }
    }
    .express-box {
      height: 114px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .express {
        padding: 3px 25px;
        font-size: 15px;
        color: #333;
        .margin-top5 {
          margin-top: 15px;
        }
        .fw-500 {
          font-weight: 500;
        }
      }
    }
    // }
  }
}
.btn {
  width: 133px;
  height: 40px;
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  background: #c6001f;
  text-align: center;
  cursor: pointer;
  margin: 40px auto 16px;
  transition: all 0.3s;
  &.pay {
    &:hover {
      background: #ee4039;
    }
  }
  &.black {
    background: #333;
    &:hover {
      background: #444;
    }
  }
  &.blank {
    color: #333;
    border: 1px solid #333;
    background-color: #fff;
    &:hover {
      opacity: 1;
      background-color: #333;
      color: #fff;
    }
  }
}
.inviteDetail {
  width: 133px;
  height: 40px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 40px;
  margin: 13px auto 16px;
}
</style>
